export const ANIMAL_LIST = [
  {
    icon: 'bat',
    width: 60,
    range: '0-4',
    activeFrom: 1,
    description: 'Your color vision is not something to write home about. Bats live in the dark and rely on other senses than sight, and that\'s what you should do too.'
  },
  {
    icon: 'mole',
    width: 60,
    range: '5-9',
    activeFrom: 5,
    description: 'You have moderate color vision. You see your closest perimeter but don\'t go on any big adventures as you will probably get lost.'
  },
  {
    icon: 'dog',
    width: 57,
    range: '10-14',
    activeFrom: 10,
    description: 'You have decent color vision. You see most of the sticks that are thrown to you but sometimes you\'re just lost.'
  },
  {
    icon: 'cat',
    width: 75,
    range: '15-19',
    activeFrom: 15,
    description: 'You have good color vision. The mice should hide when you\'re on the move.'
  },
  {
    icon: 'tiger',
    width: 90,
    range: '20-24',
    activeFrom: 20,
    description: 'Your color vision is superb. You wouldn\'t have any problems surviving in the jungle. You can see when the neighbouring tiger visits the bathroom faaaar away.'
  },
  {
    icon: 'hawk',
    width: 110,
    range: '25-29',
    activeFrom: 25,
    description: 'Wow, you have excellent color vision. You can see a worm from the top of a tree.'
  }
]
